export default "__VITE_ASSET__CuYuOfDa__"